import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Home from "./pages/Home";
import QRScanner from "./pages/QRScanner";
import CompanyLogo from "./components/CompanyLogo";
import StatusCheck from "./pages/StatusCheck";
import CheckoutPage from "./pages/CheckoutPage";
import Transaction from "./pages/Transaction";
import { StationProvider } from "./context/stationContext";
import { Layout } from "./layout";
import Dashboard from "./pages/admin/Dashboard";
import { PrivateRoute } from "./PrivateRoute/PrivateRoute";
import { AddStation } from "./pages/admin/AddStation";
import { EditStation } from "./pages/admin/EditStation";
import Login from "./pages/admin/Login";
import Enable2FA from "./pages/admin/Enable2FA";
import Verify2FA from "./pages/admin/Verify2FA";
import Settings from "./pages/admin/Settings";
import { DefaultProvider } from "./context/DefautContext";
import LanguageProvider from "./context/LanguageContext";
import LanguageSwitch from "./components/LanguageSelector";
import { useEffect } from "react";
import history from "./history";
import { ToastContainer } from "react-toastify";
import Profile from "./pages/admin/Profile";
import { CopyProvider } from "./context/CopyContext";

const queryClient = new QueryClient();

function App() {
  useEffect(() => {
    const unblock = history.block((tx) => {
      const { action } = tx;
      if (action === "POP") {
        window.history.pushState(null, "", window.location.href);
        return false;
      }
      return true;
    });

    return () => {
      unblock();
    };
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <StationProvider>
        <DefaultProvider>
          <CopyProvider>
            <BrowserRouter>
              <Layout>
                <ToastContainer />
                <CompanyLogo />
                <LanguageSwitch />
                <Routes>
                  <Route
                    path="/admin/dashboard"
                    element={
                      <PrivateRoute>
                        <Dashboard />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/admin/dashboard/station"
                    element={
                      <PrivateRoute>
                        <AddStation />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/admin/dashboard/station/:id"
                    element={
                      <PrivateRoute>
                        <EditStation />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/admin/settings"
                    element={
                      <PrivateRoute>
                        <Settings />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/admin/profile"
                    element={
                      <PrivateRoute>
                        <Profile />
                      </PrivateRoute>
                    }
                  />
                  <Route path="/" element={<Navigate to="/en" replace />} />
                  {/* <Route path="/register" element={<Register />} /> */}
                  <Route path="/login/" element={<Login />} />
                  <Route path="/enable-2fa/" element={<Enable2FA />} />
                  <Route path="/verify-2fa/" element={<Verify2FA />} />
                  <Route path="/" element={<Navigate to="/en" replace />} />
                  <Route
                    path="/:lang"
                    element={
                      <LanguageProvider>
                        <Home />
                      </LanguageProvider>
                    }
                  />
                  <Route
                    path="/:lang/scanner"
                    element={
                      <LanguageProvider>
                        <QRScanner />
                      </LanguageProvider>
                    }
                  />
                  <Route
                    path="/:lang/status-check/:stationId/"
                    element={
                      <LanguageProvider>
                        <StatusCheck />
                      </LanguageProvider>
                    }
                  />
                  <Route
                    path="/:lang/checkout-page"
                    element={
                      <LanguageProvider>
                        <CheckoutPage />
                      </LanguageProvider>
                    }
                  />
                  <Route
                    path="/:lang/transaction-details"
                    element={
                      <LanguageProvider>
                        <Transaction />
                      </LanguageProvider>
                    }
                  />
                </Routes>
              </Layout>
            </BrowserRouter>
          </CopyProvider>
        </DefaultProvider>
      </StationProvider>
    </QueryClientProvider>
  );
}

export default App;
